import e from"./Hits.vue_vue&type=script&lang.js";import{render as t}from"./Hits.vue_vue&type=template&id=19b8dc8f&lang.js";e.render=t;export default e;
//# sourceMappingURL=Hits.vue.js.map
